import React from "react";
import _ from "underscore";
import { isNotEmpty } from "../../../framework/utils";
import { optional, parseBoolean } from "../../../utils/lang";
import * as SurveyUtils from "../../utils/surveys";

export const GRADE_TYPES = {
    SCORE: "score",
    RATING: "rating",
    TREND: "trend",
};

class GradedValue extends React.Component {

    getContent() {
        return isNotEmpty(this.props.children)
            ? this.props.children
            : this.props.value
    }

    render() {
        return(
            <div
                {...this.props}
            >
                {this.getContent()}
            </div>
        )
    }
}

export function gradedComponent(Component) {
    return class WrapperComponent extends React.Component {
        getValue() {
            const value = this.props.value,
                roundValue = parseBoolean(optional(this.props.roundValue, true));
    
            return roundValue && _.isNumber(value)
                ? Math.round(value)
                : value;
        }
    
        getGrade() {
            const value = this.props.value,
                gradeType = this.props.gradeType;
    
            switch (gradeType) {
                case GRADE_TYPES.SCORE:
                    return SurveyUtils.gradeScore(value);
                case GRADE_TYPES.RATING:
                    return SurveyUtils.gradeRating(value);
                case GRADE_TYPES.TREND:
                    return SurveyUtils.gradeTrend(value);
                default:
                    return value;
            }
        }
    
        render() {
            const value=this.getValue(),
                grade = this.getGrade(),
                baseClassName = optional(this.props.baseClassName, "graded-value"),
                invert = parseBoolean(optional(this.props.invert), false),
                sanitizedProps = _.omit(
                        this.props,
                        "className",
                        "baseClassName",
                        "value",
                        "roundValue",
                        "invert",
                        "gradeType",
                    );

            let className = `${baseClassName} ${baseClassName}--grade-${grade}`;

            if (invert) {
                className += ` ${baseClassName}--invert`;
            }

            if (isNotEmpty(this.props.className)) {
                className += ` ${this.props.className}`;
            }

            return(
                <Component
                    {...sanitizedProps}
                    className={className}
                    value={value}
                />
            )
        }
    }
}

export default gradedComponent(GradedValue);